export default __webpack_public_path__ + "static/media/main.8c70bd70.jpeg";